export enum ChartType {
  SALES = 'sales',
  DEMO = 'demo',
  ASSIGNED = 'assigned',
  COMPLETED = 'completed'
}

export type DashboardProps = {
  date_from: string
  date_to: string
  days?: number
  user?: number
  branch?: number
  currentYear: boolean
}

export type ChartDataItem = {
  name: string
  Name_count: number
  [key: string]: string
}
